import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/series/')({
  component: lazyRouteComponent(() => import('./-index')),
})
